var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.clickAway,
          expression: "clickAway",
        },
      ],
      staticClass: "relative cursor-pointer",
      class: _vm.tooltipClasses,
      on: { click: _vm.clickTooltip },
    },
    [
      _vm._t("default"),
      _vm.isTooltipVisible
        ? _c(
            "div",
            {
              staticClass: "custom-tooltip",
              class: _vm.TooltipStyle,
              attrs: { tabindex: "1" },
            },
            [_vm._t("content")],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }